"use strict";
/*
 * Created on 3. 5. 2019
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
}); //tslint:disable:max-classes-per-file

/**
 * Wrapper over standard Map implementation that allows sorting map values is LRU fashion. LRU values may be retrieved
 * and deleted from map.
 *
 * @author Stepan Mik
 */

var LRUMap =
/*#__PURE__*/
function () {
  function LRUMap() {
    _classCallCheck(this, LRUMap);

    this.inner = new Map();
    this.first = new Wrapper(null, null);
    this.last = new Wrapper(null, null);
    this[Symbol.toStringTag] = 'Map';
    this.last.prev = this.first;
    this.first.next = this.last;
  }

  _createClass(LRUMap, [{
    key: Symbol.iterator,
    value: function value() {
      return this.entries();
    }
  }, {
    key: "clear",
    value: function clear() {
      this.inner.clear();
      this.last.prev = this.first;
      this.first.next = this.last;
    }
  }, {
    key: "delete",
    value: function _delete(key) {
      var w = this.inner.get(key);

      if (!w) {
        return false;
      }

      this.inner.delete(key);
      w.unlink();
      return true;
    }
  }, {
    key: "wrapperIterator",
    value: function wrapperIterator(map) {
      var outer = this;
      return new (
      /*#__PURE__*/
      function () {
        function _class(wrapper) {
          _classCallCheck(this, _class);

          this.wrapper = wrapper;
        }

        _createClass(_class, [{
          key: Symbol.iterator,
          value: function value() {
            return this;
          }
        }, {
          key: "next",
          value: function next() {
            if (this.wrapper === outer.last) {
              return {
                done: true,
                value: undefined
              };
            } else {
              var ret = {
                done: false,
                value: map(this.wrapper)
              };
              this.wrapper = this.wrapper.next;
              return ret;
            }
          }
        }]);

        return _class;
      }())(this.first.next);
    }
  }, {
    key: "entries",
    value: function entries() {
      return this.wrapperIterator(function (w) {
        return [w.key, w.value];
      });
    }
  }, {
    key: "forEach",
    value: function forEach(effect, thisArg) {
      if (thisArg !== undefined) {
        throw new Error('thisArg is not supported');
      }

      var w = this.first.next;

      while (w !== this.last) {
        effect(w.value, w.key, this);
        w = w.next;
      }
    }
  }, {
    key: "get",
    value: function get(key) {
      var w = this.inner.get(key);
      return w ? w.value : undefined;
    }
  }, {
    key: "has",
    value: function has(key) {
      return this.inner.has(key);
    }
  }, {
    key: "keys",
    value: function keys() {
      return this.wrapperIterator(function (w) {
        return w.key;
      });
    }
  }, {
    key: "set",
    value: function set(key, value) {
      var w = this.inner.get(key);

      if (w) {
        w.unlink();
        w.value = value;
      } else {
        w = new Wrapper(key, value);
        this.inner.set(key, w);
      }

      this.last.prev.append(w);
      return this;
    }
  }, {
    key: "values",
    value: function values() {
      return this.wrapperIterator(function (w) {
        return w.value;
      });
    }
    /**
     * Removes n least recently used entries from the map and returns them. If n is larger than map size,
     * it is made equal to the size.
     * @param n number of entries to remove from map
     * @returns up to n entries removed from the map
     */

  }, {
    key: "take",
    value: function take(n) {
      var ret = [];
      var f = this.first.next;

      while (n > 0 && f !== this.last) {
        ret.push([f.key, f.value]);
        this.inner.delete(f.key);
        f = f.next;
        n--;
      }

      this.first.next = f;
      f.prev = this.first;
      return ret;
    }
  }, {
    key: "size",
    get: function get() {
      return this.inner.size;
    }
  }]);

  return LRUMap;
}();

exports.LRUMap = LRUMap;

var Wrapper =
/*#__PURE__*/
function () {
  function Wrapper(key, value) {
    _classCallCheck(this, Wrapper);

    this.key = key;
    this.value = value;
    this.next = this;
    this.prev = this;
    /**/
  }

  _createClass(Wrapper, [{
    key: "unlink",
    value: function unlink() {
      this.prev.next = this.next;
      this.next.prev = this.prev;
      this.prev = this;
      this.next = this;
    }
  }, {
    key: "append",
    value: function append(other) {
      other.next = this.next;
      other.next.prev = other;
      this.next = other;
      other.prev = this;
    }
  }]);

  return Wrapper;
}();